export default "__VITE_ASSET__ChChx5dw__"